import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const incomeRoute = {
    SAVE: "dashboard/income/special/save",
    LIST: "dashboard/income/special/list",
    LIST_ENTITY: "dashboard/income/special/list/entity",
    FIND_BY_ID: "dashboard/income/special/findById",
    DELETE_INCOME: "dashboard/income/special/delete",
};
export default {
    save(subscriber) {
        let code = -1;
        return new Promise(resolve => {
            const method = subscriber.code ? "put" : "post";
            http[method](incomeRoute.SAVE, subscriber)
                .then(({data}) => {
                    code = data.code;
                    if (code > 0) {
                        toast.ok("Se registró el abonado correctamente");
                        return;
                    }
                    toast.error(data.message);
                })
                .catch(() => toast.error("Error al guardar el abonado"))
                .finally(() => resolve(code));
        });
    },
    list(objCriteria) {
        return new Promise(resolve => {
            let newData = {};
            http.get(incomeRoute.LIST, {
                params: objCriteria
            }).then(({data}) => {
                console.log(data);
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                if (!data.info.records || data.info.records.length === 0) {
                    toast.info("No se encontraron los mensuales con los criterios ingresados");
                    return;
                }
                newData = data.info;
            }).catch(() => toast.error("Error al consultar los mensuales"))
                .finally(() => resolve(newData));
        });
    },
    listEntity(companyId, criteria) {
        let newData = [];
        if (!companyId) {
            toast.error("Debe seleccionar una empesa");
            return new Promise(resolve => resolve(newData));
        }
        return new Promise(resolve => {
            http.get(incomeRoute.LIST_ENTITY,
                {params: {companyId, criteria}})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron resultados con la identificación o nombre");
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al consultar los propietarios");
                        return;
                    }
                    newData = data.info;
                })
                .catch(() => toast.error("Error al consultar los propietarios"))
                .finally(() => resolve(newData));
        });
    },
    findById(specialId) {
        return new Promise(resolve => {
            let income = null;
            http.get(incomeRoute.FIND_BY_ID, {params: {specialId}})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron resultados")
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al consultar la información del mensual");
                        return;
                    }
                    income = data.info;
                }).catch(() => toast.error("Error al consultar la información del mensual"))
                .finally(() => resolve(income));
        });
    },
    deleteIncome(specialId) {
        let resultCode = -1;
        return new Promise(resolve => {
            http.delete(incomeRoute.DELETE_INCOME, {params: {specialId}})
                .then(({data}) => {
                    resultCode = data.code;
                }).finally(() => resolve(resultCode));
        });
    }

};